import React from 'react';

import { Form } from 'common/components';

const UserActions = ({
  t,
  companyId,
  id,
  isActive,
  isRoot,
  canToggle,
  canUpdate,
  isLoading,
  handleToggle = () => {},
}) => {
  return (
    <div className="nowrap">
      {!isRoot && canToggle && (
        <Form.Button
          text={t(isActive ? 'actions.deactivate' : 'actions.activate')}
          type={'button'}
          color={'secondary'}
          isLoading={isLoading}
          extraClassName={'btn-sm mr-2'}
          onClick={(e) => {
            e.preventDefault();
            handleToggle(id);
          }}
        />
      )}

      {!isRoot && canUpdate && (
        <Form.Link
          to={`/companies/${companyId}/users/${id}/edit`}
          className="btn btn-sm btn-primary"
        >
          {t('actions.edit')}
        </Form.Link>
      )}
    </div>
  );
};

export default UserActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/users/components/UserActions.js